import { Navigate, Outlet, RouteObject } from 'react-router-dom'
import TeacherDashboard from '../../pages/Dashboard/TeacherDashboard'
import { lazy } from 'react'
import { tabNames } from '../helpers'
import { useSelector } from 'react-redux'
import { RootState } from '../../redux/store'
import LoadingSpinner from '../../components/LoadingSpinner/LoadingSpinner'

// prettier-ignore
const HomePage = lazy(() => import('../../pages/Dashboard/HomePage/TeacherHomePage').then((module) => ({ default: module.default, })) )
// prettier-ignore
const MyAccountPage = lazy(() => import('../../pages/Dashboard/MyAccountPage').then((module) => ({ default: module.default, })) )
// prettier-ignore
// const HelpDeskPage = lazy(() => import('../../pages/Dashboard/HelpDeskPage').then((module) => ({ default: module.default, })) )
// prettier-ignore
const ReviewPage = lazy(() => import('../../pages/Dashboard/ReviewPage').then((module) => ({ default: module.default, })) )
// prettier-ignore
const PreempDocsPage = lazy(() => import('../../pages/Dashboard/PreemploymentDocsPage').then((module) => ({ default: module.default, })) )

// prettier-ignore
const SettingsPage = lazy(() => import('../../pages/Dashboard/SettingsPage/teacher/layout').then((module) => ({ default: module.default, })) )
// prettier-ignore
const SettingsDetails = lazy(() => import('../../pages/Dashboard/SettingsPage/teacher/details').then((module) => ({ default: module.default, })) )
// prettier-ignore
const SettingsEmailNotifications = lazy(() => import('../../pages/Dashboard/SettingsPage/teacher/emailNotifications').then((module) => ({ default: module.default, })) )

const PageNotFound = lazy(() =>
    import('../../components/ErrorFallback/PageNotFound').then((m) => ({
        default: m.default,
    }))
)

const TeacherProtectedRoute = () => {
    const teacherLoaded = useSelector(
        (state: RootState) => state.userReg.dataLoaded
    )
    const rejectedState = useSelector(
        (state: RootState) => state.userReg.rejectedState
    )

    if (!teacherLoaded) {
        return <LoadingSpinner fillViewPortHeight fillViewPortWidth />
    }

    if (!!rejectedState) {
        return <Navigate to={tabNames.app.teacher.index} replace />
    }

    return <Outlet />
}

const teacherRoutes: RouteObject = {
    path: 'teacher',
    element: <TeacherDashboard />,
    children: [
        {
            index: true,
            element: <HomePage />,
            handle: {
                meta: {
                    title: 'Home - Spark Relief Teachers',
                    description: 'Manage your account here',
                },
            },
        },
        {
            element: <TeacherProtectedRoute />,
            children: [
                {
                    path: tabNames.app.teacher.MY_ACCOUNT,
                    element: <MyAccountPage />,
                    handle: {
                        meta: {
                            title: 'My Account - Spark Relief Teachers',
                            description: 'Access your account here',
                        },
                    },
                },
                {
                    path: tabNames.app.teacher.PREEMP,
                    element: <PreempDocsPage />,
                    handle: {
                        meta: {
                            title: 'Getting You Paid - Spark Relief Teachers',
                            description: 'Manage your employment documents',
                        },
                    },
                },
                {
                    path: tabNames.app.teacher.REVIEW,
                    element: <ReviewPage />,
                    handle: {
                        meta: {
                            title: 'Review - Spark Relief Teachers',
                            description:
                                'Review your information before submission',
                        },
                    },
                },
            ],
        },
        // {
        //     path: tabNames.app.teacher.HELP,
        //     element: <HelpDeskPage />,
        //     handle: {
        //         meta: {
        //             title: 'Help Desk - Spark Relief Teachers',
        //             description: 'Submit questions or any feedback here',
        //         },
        //     },
        // },
        {
            path: tabNames.app.teacher.SETTINGS.index,
            element: <SettingsPage />,
            children: [
                {
                    index: true,
                    element: (
                        <Navigate
                            to={tabNames.app.teacher.SETTINGS.DETAILS}
                            replace
                        />
                    ),
                },
                {
                    path: tabNames.app.teacher.SETTINGS.DETAILS,
                    element: <SettingsDetails />,
                },
                {
                    path: tabNames.app.teacher.SETTINGS.NOTIFICATIONS,
                    element: <SettingsEmailNotifications />,
                },
            ],
            handle: {
                meta: {
                    title: 'Settings - Spark Relief Teachers',
                    description: 'Update your basic information',
                },
            },
        },
        {
            path: '*',
            element: <PageNotFound homeLink={tabNames.app.teacher.index} />,
            handle: {
                meta: {
                    title: 'Page not found - Spark Relief Teachers',
                },
            },
        },
    ],
}

export default teacherRoutes
